export function initNav() {
    document.addEventListener("DOMContentLoaded", () => {
        const header = document.querySelector(".site-header");
        const toggle = document.querySelector(".c-nav-toggle");
        const nav = document.querySelector("#site-navigation");

        if (!header || !toggle || !nav) return;

        const openMenu = () => {
            header.classList.add("is-nav-open");
            document.body.classList.add("is-nav-open");
            toggle.setAttribute("aria-expanded", "true");
        };

        const closeMenu = () => {
            header.classList.remove("is-nav-open");
            document.body.classList.remove("is-nav-open");
            toggle.setAttribute("aria-expanded", "false");
        };

        const toggleMenu = () => {
            const isOpen = header.classList.contains("is-nav-open");
            if (isOpen) {
                closeMenu();
            } else {
                openMenu();
            }
        };

        toggle.addEventListener("click", toggleMenu);

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                closeMenu();
            }
        });

        nav.querySelectorAll("a").forEach((link) => {
            link.addEventListener("click", () => {
                closeMenu();
            });
        });

        window.addEventListener("resize", () => {
            if (window.innerWidth >= 1024) {
                closeMenu();
            }
        });
    });
}